import { render, staticRenderFns } from "./AllocationDate.vue?vue&type=template&id=31cf1d78"
import script from "./AllocationDate.vue?vue&type=script&lang=js"
export * from "./AllocationDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports